import { useEffect } from "react";

// Keeps <html lang> in step with the active UI locale (screen readers, translation prompts, hyphenation).
export default function useDocumentLang(locale) {
  useEffect(() => {
    document.documentElement.lang = locale || "it";
  }, [locale]);
}
